<!--
 * @Author: your name
 * @Date: 2022-02-21 18:33:57
 * @LastEditTime: 2022-02-22 11:12:15
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \rightcloud-console\src\views\privacy-statement.vue
-->
<template>
    <div class="service-agree-container">
        <div id="agree"
             class="rc-service-agreement">
            <div style="width:1140px;margin:0 auto;">
                <div class="table-container announcementDetails">
                    <h2>{{announcementData.noticeTitle}}</h2>
                    <div class="content">
                        <div class="announcement-details-content ql-editor"
                             v-html="announcementData.noticeContent"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/service/api'
export default {
    name: 'ServiceAgreement',
    data () {
        return {
            announcementData: {
                noticeTitle: '隐私声明',
                noticeContent: ''
            }
        }
    },
    created () {
        this.getDitail()
    },
    methods: {
        getDitail () {
            this.announcementData.noticeContent = ''
            this.axios.get(this.urlFormat(API.CONFIGS_NONAUTH, true), { headers: { noAuth: true } }).then(res => {
                const logintips = res.find(item => item.configKey === 'logintips.privacy')
                if (logintips) {
                    this.announcementData.noticeContent = logintips.configValue
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.service-agree-container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .announcementDetails {
        // width: 90%;
        // margin: 15px auto;
        padding: 0 25px;
        height: calc(~'100% - 65px');
        h2 {
            display: block;
            margin-bottom: 20px;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: #666;
            padding: 40px 0 0px 0;
        }
        .info {
            color: #999;
            padding: 0 0 10px 0;
            border-bottom: 1px dotted #ddd;
            .time {
                float: right;
            }
        }
        .content {
            height: calc(~'100% - 100px');
            // overflow-y: auto;
            .announcement-details-content {
                padding: 15px 0;
                margin: 10px 0;
                // font-size: 12px;
                font-size: 1.15em;
                color: #444;
                line-height: 1.8em;
                // p {
                //     text-indent: 2em;
                // }
            }
        }
    }
}
</style>
<style lang="less">
@import './console/announcement/components/style.css';
</style>
